import React from 'react';
import { RefinementList } from 'react-instantsearch-dom';

// import Button from '3-components/Buttons/Button';
// import CustomRefinementCount from './CustomRefinementCount';
import AccordionItem from '3-components/Accordion/AccordionItem';
// import useViewport from './useViewport';

interface CustomRefinementListMobileProps {
    // seeAllText: string;
    filterAttribute: string;
    label: string;
    defaultRefinement?: [string] | null;
    // responsiveBreakpoint?: number;
    // selectedAttribute?: string;
}

const CustomRefinementListMobile = (props: CustomRefinementListMobileProps) => {
    const { filterAttribute, label, defaultRefinement } = props;

    return (
        <AccordionItem
            accordionHeading={label}
            headerTag="h5"
        >
            <div className="custom-refinement-list-mobile">
                <RefinementList attribute={filterAttribute} facetOrdering={true} defaultRefinement={defaultRefinement} />
            </div>
        </AccordionItem>
    );
};

export default CustomRefinementListMobile;
